export const iconFontAwesomeHumanitarianBaby = (
	<i className="fa-solid fa-baby"></i>
);
